"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var homeDashboard_1 = require("../../../components/dashboard/homeDashboard");
var console_1 = require("../../../reducers/slices/console");
var react_redux_1 = require("react-redux");
var react_1 = require("react");
var HomePage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Dashboard"));
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { className: "h-full overflow-y-auto", children: (0, jsx_runtime_1.jsx)(homeDashboard_1.HomeDashboard, {}) }));
};
exports.HomePage = HomePage;
